<template>
  <div>
    <el-dialog
      width="1600px"
      title="工艺列表"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <el-button v-if="isAdmin" class="m-b-10" type="success" size="mini" @click="itemDo()">
          新增工艺
        </el-button>
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          v-bind="tableOptions"
          :height="this.$util.getViewHeight() - 280"
          :cell-class-name="cellClassName"
        >
          <!-- slot_header -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              @change="headerFilterChange"
            />
          </template>

          <!-- slot_default -->
          <template #default_create_date="{ row }">
            {{ row.create_date ? row.create_date.slice(0, 10) : '' }}
          </template>
          <template #default_she_bei_list="{ row }">
            {{ row.she_bei_list ? row.she_bei_list.length : 0 }}
          </template>
          <template #default_gong_xu_list="{ row }">
            <div v-if="row.gong_xu_list.length" class="sort-box">
              <div v-for="(item, index) in row.gong_xu_list" :key="index" class="sort-item">
                <span v-if="index" class="iconfont icon-arrow-right"></span>
                <span>{{ item.name || '空' }}</span>
              </div>
            </div>
            <span v-else class="c-gray-light">未绑定工序</span>
          </template>
          <template #default_ststus="{ row }">
            <el-tag v-if="row.status" size="mini" type="success">已启用</el-tag>
            <el-tag v-else size="mini" type="danger">已禁用</el-tag>
          </template>
          <template #default_operate="{ row }">
            <el-link v-if="row.id !== bind_id" type="success" @click="itemChoose(row)"
              >选择该工艺</el-link
            >
            <el-link type="primary" @click="itemDo(row.id)">编辑</el-link>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
    </el-dialog>
    <!-- 弹窗-增改工艺 -->
    <PopupDoGongYi
      v-if="isShowPopupDoGongYi"
      :show.sync="isShowPopupDoGongYi"
      :detailId="detailId"
      @success="searchListData"
    />
  </div>
</template>

<script>
import PopupDoGongYi from '@/views/new/gongyi/common/popup-do'
export default {
  components: {
    PopupDoGongYi
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    bind_id: {
      type: [Number, String, Object],
      default: ''
    }
  },
  data() {
    return {
      selfShow: false,
      filterData: {},
      detailId: '',
      isShowPopupDoGongYi: false,
      headerFilterUrl: '/admin/gcvip/gongyi/searchHeard',
      tableOptions: {
        loading: true,
        size: 'mini',
        border: true,
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          {
            fixed: 'left',
            title: '序号',
            type: 'seq',
            width: 40
          },
          {
            fixed: 'left',
            title: '工艺编码',
            field: 'code',
            slots: { header: 'header_input' },
            width: 80
          },
          {
            title: '工艺名称',
            field: 'mu_ban_ming_cheng',
            slots: { header: 'header_input' }
          },
          {
            title: '关联类目',
            field: 'lei_mu_name',
            slots: { header: 'header_input' }
          },
          {
            title: '工艺描述',
            field: 'gong_yi_bei_zhu',
            slots: { header: 'header_input' }
          },
          {
            title: '创建人',
            field: 'create_name',
            slots: { header: 'header_input' }
          },
          {
            title: '创建时间',
            field: 'create_date',
            slots: { default: 'default_create_date' }
          },
          {
            field: 'she_bei_list',
            title: '关联设备',
            slots: { default: 'default_she_bei_list' },
            width: 80
          },
          {
            field: 'gong_xu_list',
            title: '工序组成',
            slots: { default: 'default_gong_xu_list' },
            width: 300
          },
          {
            field: 'status',
            title: '状态',
            width: 80,
            slots: { default: 'default_ststus' }
          },
          {
            fixed: 'right',
            title: '操作',
            width: 120,
            slots: { default: 'default_operate' }
          }
        ],
        data: []
      }
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.searchListData()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true
      let params = {
        currentPage: this.tableOptions.pagerConfig.currentPage,
        pageSize: this.tableOptions.pagerConfig.pageSize,
        filterData: this.filterData,
        sortData: { id: 'desc' }
      }
      if (this.bind_id) params.choose_ids = [this.bind_id]
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongyi/list3',
        data: params
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = res.data.page.list
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    // 行-已选样式
    cellClassName(rowData) {
      let result = rowData.row.id === this.bind_id ? 'table-row-choose' : ''
      return result
    },
    // 项-增改
    itemDo(id = '') {
      this.detailId = id
      this.isShowPopupDoGongYi = true
    },
    // 项选择
    itemChoose(row) {
      this.selfShow = false
      this.$emit('update:show', false)
      this.$emit('success', row)
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .sort-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 18px;
    padding: 0 5px;
    color: @colorWhite;
    background-color: @colorBlue;
    border-radius: 2px;
    cursor: pointer;
    .sort-item {
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        width: 20px;
      }
    }
  }
}
</style>
